import HomepageSections from './homepage-sections';
import Seo from '@/components/seo';
import homepageSeo from '@/data/homepage-seo.json';
export default function LandingPage() {
 return <><Seo title={homepageSeo.title} titleIsComplete description={homepageSeo.description} keywords={homepageSeo.keywords.join(', ')} path="/" /><HomepageSections /></>;
}
